import { validate as isUUID } from 'uuid';
import { z } from 'zod';

import { unique } from '@vestigas/utils';

export const zodCustomFieldsBulkPayloadSchema = z.object({
  ids: z.tuple([z.string()], z.string()).transform((ids) => {
    // Remove non-UUID items and keep only valid UUIDs
    const validUuids = ids.filter(isUUID);

    return unique(validUuids).sort();
  }),
  includeOptions: z.boolean().optional().prefault(false),
  language: z.string().optional(),
});
